import { type MarketItem, MarketItemType } from '../model/market.types';

export const isPlaydeckSubscriptionMarketItem = <
  T extends Pick<MarketItem, 'type' | 'isSubscription'>,
>(
  item: T
): item is T & { type: MarketItemType.LOOTBOX; isSubscription: true } => {
  return !!(item.type === MarketItemType.LOOTBOX && item.isSubscription);
};
